import React from 'react';
import './styles.scss';

export default function ConfirmationField({ title, children, halfWidth = false, broadTitle = false, className = '' }) {
  const titleColWidth = title === null ? 0 : broadTitle ? 5 : halfWidth ? 4 : 3;
  const contentColWidth = 12 - titleColWidth;

  return [
    <div className={`confirmation-field col-xs-12 ${className}`} key={title}>
      <div className="row">
        <div className={`col-md-${titleColWidth} confirmation-field__title`}>{title}</div>
        <div className={`col-md-${contentColWidth} confirmation-field__content`}>{children}</div>
      </div>
    </div>
  ];
}
